import {Component, OnInit} from '@angular/core';
import {ScrollService} from '../../lib/services/scroll/scroll.service';


@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(protected scroll: ScrollService) {}

  ngOnInit() {
    this.scroll.scrollToContentOnNavigationEnd();
  }

}
